<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col-3">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
      <div class="col text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailMembership' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span style="margin-right: 1rem">Show</span>
          <b-form-select
            class="form-control"
            style="width: 20%"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span style="margin-left: 1rem">entries</span>
        </div>
        <div class="d-flex align-items-center justify-content-end col">
          <label for="searchText" class="mx-3">Search: </label>
          <input
            id="searchText"
            type="text"
            v-model="searchText"
            class="form-control w-50"
            @change="getMemberships"
          />
        </div>
      </div>

      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="memberships"
        :per-page="perPage"
        @sort-changed="sortCompare"
      >
        <template #cell(minimumFirstPurchase)="data">
          <div class="text-right">
            {{ data.item.minimumFirstPurchase.toLocaleString() }}
          </div>
        </template>
        <template #cell(minimumAccumulativePurchase)="data">
          <div class="text-right">
            {{ data.item.minimumAccumulativePurchase.toLocaleString() }}
          </div>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{ name: 'DetailMembership', query: { id: data.item.id } }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import MembershipService from "services/api/membership.service";
import DefaultListViewData from "@/views/defaultListViewData";
export default {
  components: {
    BrandDropdown,
  },
  data() {
    return {
      ...DefaultListViewData,
      memberships: [],
      fields: [
        this.assembleField("id", "ID", true),
        this.assembleField("brandName", "Brand", true),
        this.assembleField("name", "Membership program", true),
        this.assembleField("level", "Level", true),
        this.assembleField(
          "minimumFirstPurchase",
          "Minimum first purchase(after discount)",
          true
        ),
        this.assembleField(
          "minimumAccumulativePurchase",
          "Minimum accumulative purchase(after discount)",
          true
        ),
        this.assembleField("startDate", "Start date", true),
        this.assembleField("endDate", "End date", true),
        this.assembleField("status", "status"),
        this.assembleField("action", "Action"),
      ],
    };
  },
  mounted() {
    this.isLoading = true;
    this.getMemberships(this.sort);
  },
  methods: {
    async getMemberships(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brand: this.brandSelected?.id,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await MembershipService.getMemberships(param)
          .then(async (res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.memberships = await data.membershipTiers;
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      this.getMemberships(this.sort);
    },
    assembleField(key, label, sort) {
      return {
        key: key,
        label: label,
        sortable: sort,
      };
    },
    changePage() {
      this.getMemberships(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      if (e.sortBy === "brandName") {
        sortBy = "brand.brandName";
      }
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getMemberships(this.sort);
    },
    onChangeEntries() {
      this.getListBrands(this.sort);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.btn-del {
  color: red;

  .btn-del:hover {
    color: white;
  }
}
</style>
